<script setup>
import { cn } from "@/lib/utils.js";

const props = defineProps({
  error: {
    type: Boolean,
    default: false,
    required: false,
  },
  message: {
    type: String,
    required: true,
  },
  class: {
    type: String,
    default: "",
  },
});
</script>

<template>
  <div :class="cn('w-full pt-2 flex items-center px-1', props.class)">
    <div>
      <svg
        v-if="error"
        width="17"
        height="17"
        viewBox="0 0 17 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.5 12.7141C8.66496 12.7141 8.80317 12.6584 8.91461 12.5469C9.02543 12.4355 9.08083 12.2973 9.08083 12.1323C9.08083 11.968 9.02511 11.8301 8.91367 11.7187C8.80222 11.6072 8.66433 11.5512 8.5 11.5506C8.33567 11.5499 8.19778 11.6056 8.08633 11.7177C7.97489 11.8298 7.91917 11.9677 7.91917 12.1314C7.91917 12.2951 7.97489 12.4333 8.08633 12.546C8.19778 12.6587 8.33567 12.7154 8.5 12.7141ZM8.02778 9.58894H8.97222V3.92228H8.02778V9.58894ZM8.50283 17C7.32794 17 6.22294 16.7771 5.18783 16.3313C4.15335 15.8849 3.2533 15.2792 2.48767 14.5142C1.72204 13.7492 1.11602 12.8501 0.669611 11.8169C0.223204 10.7837 0 9.67898 0 8.50283C0 7.32668 0.223204 6.22168 0.669611 5.18783C1.11539 4.15335 1.72015 3.2533 2.48389 2.48767C3.24763 1.72204 4.14706 1.11602 5.18217 0.669611C6.21728 0.223204 7.32228 0 8.49717 0C9.67206 0 10.7771 0.223204 11.8122 0.669611C12.8466 1.11539 13.7467 1.72046 14.5123 2.48483C15.278 3.2492 15.884 4.14863 16.3304 5.18311C16.7768 6.21759 17 7.32228 17 8.49717C17 9.67205 16.7771 10.7771 16.3313 11.8122C15.8856 12.8473 15.2799 13.7473 14.5142 14.5123C13.7486 15.2773 12.8495 15.8834 11.8169 16.3304C10.7843 16.7774 9.67961 17.0006 8.50283 17ZM8.5 16.0556C10.6093 16.0556 12.3958 15.3236 13.8597 13.8597C15.3236 12.3958 16.0556 10.6093 16.0556 8.5C16.0556 6.39074 15.3236 4.60417 13.8597 3.14028C12.3958 1.67639 10.6093 0.944444 8.5 0.944444C6.39074 0.944444 4.60417 1.67639 3.14028 3.14028C1.67639 4.60417 0.944444 6.39074 0.944444 8.5C0.944444 10.6093 1.67639 12.3958 3.14028 13.8597C4.60417 15.3236 6.39074 16.0556 8.5 16.0556Z"
          fill="#F51A80"
        />
      </svg>
      <svg
        v-else
        xmlns="http://www.w3.org/2000/svg"
        height="24"
        viewBox="0 0 24 24"
        width="24"
        class="text-errors w-full max-w-5"
      >
        <g>
          <path
            class="fill-current"
            d="M12,19c0-3.87,3.13-7,7-7c1.08,0,2.09,0.25,3,0.68V6c0-1.1-0.9-2-2-2H4C2.9,4,2,4.9,2,6v12c0,1.1,0.9,2,2,2h8.08 C12.03,19.67,12,19.34,12,19z M4,6l8,5l8-5v2l-8,5L4,8V6z M17.34,22l-3.54-3.54l1.41-1.41l2.12,2.12l4.24-4.24L23,16.34L17.34,22z"
          />
        </g>
      </svg>
    </div>
    <div class="caption ml-2">
      <p class="leading-none text-errors !m-0" v-html="message" />
    </div>
  </div>
</template>

<style scoped></style>
